import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import { choiceDialogName } from './const';
import useData from './hooks';
import { ChoiceDialogProps } from './types';
import MessageDialog from '10.quickConnect.app/components/shared/Dialogs/MessageDialog';
import { MessageDialogOption } from '10.quickConnect.app/components/shared/Dialogs/MessageDialog/types';
import OuSwitchPrompt from '10.quickConnect.app/components/shared/Dialogs/OuSwitchPrompt';

// Ouverture d'un formulaire qui a déjà des brouillons
const DeclarationAlreadySavedDialog = ({ drafts, onCreateDeclaration, open, onClose }: ChoiceDialogProps) => {
  const { t } = useTranslation('forms');

  const { onContinueDeclaration, onDeleteDeclaration, hasSingleDraft, promptProps } = useData(drafts, onClose);

  // Un seul brouillon : il peut aussi être supprimé
  const deleteOptions: MessageDialogOption[] = hasSingleDraft
    ? [
        {
          name: 'dialog-option-delete-dcl',
          label: t('qcapp_delete_form_type_info').toString(),
          icon: <DeleteIcon />,
          onClick: onDeleteDeclaration,
        },
      ]
    : [];

  return (
    <>
      <MessageDialog
        name={choiceDialogName}
        open={open}
        onClose={onClose}
        title={t('qcapp_alert_dialog_save_form_title').toString()}
        message={t('qcapp_alert_form_type_info').toString()}
        options={[
          {
            name: 'dialog-option-create-dcl',
            label: t('qcapp_new_form_type_info').toString(),
            icon: <AddIcon />,
            onClick: onCreateDeclaration,
          },
          ...deleteOptions,
          {
            name: 'dialog-option-continue-dcl',
            label: t('qcapp_get_form_type_info').toString(),
            icon: <EditIcon />,
            onClick: onContinueDeclaration,
          },
        ]}
        closeLabel={t('qcapp_dialog_item_data_close').toString()}
      />
      <OuSwitchPrompt {...promptProps} />
    </>
  );
};

export default observer(DeclarationAlreadySavedDialog);
